import { RefiAppTimeout } from './app-timeout.component.js';
import { defineRefiElement } from '../../utils/define-refi-element.js';
import '../../utils/track-analytics-event.js';

defineRefiElement('refi-common-app-timeout', RefiAppTimeout);
